<template>
    <div v-if="!loading">
        <a class="header-menu-item _notifications" @click.prevent="sidebar_open = !sidebar_open">
            <div>
                <div class="notification-count">
                    {{ notifications.length }}
                </div>
                <i class="fa fa-bell"></i>
            </div>
        </a>
        <div class="notification-sidebar" v-show="sidebar_open">
            <div class="flex justify-between p-6 txt-lg">
                <div class="pr-3 cursor-pointer" v-if="notifications.length > 0" @click.stop="markAllAsRead">
                    <strong>Clear all</strong>
                </div>
                <div class="align-right" @click="sidebar_open = false">
                    <i class="fal fa-times"></i>
                </div>
            </div>
            <div v-if="notifications.length > 0" class="notification-list-items">
                <div class="notification-list-item" v-for="notification in notifications">
                    <div class="mb-3 flex justify-between">
                        <div>
                            <i class="fal fa-envelope"></i>
                            {{ notification.friendly_created_at }}
                        </div>
                        <div @click.stop="markAsRead(notification)" class="cursor-pointer">
                            <i class="fal fa-times"></i>
                        </div>
                    </div>
                    <div class="mb-3">
                        <strong>{{ notification.title }}</strong>
                    </div>
                    <div class="content">
                        {{ notification.content }}
                    </div>
                    <div class="align-right mt-3">
                        <a class="btn-primary _sm" @click.stop="goToActionUrl(notification)">
                            {{ notification.action_button_text }}
                        </a>
                    </div>
                </div>
            </div>
            <div v-else class="p-6">
                There are no notifications to show.
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../app'

export default {
    created () {
      EventBus.$on('toggle-notification-sidebar', (data) => {
        this.sidebar_open = !this.sidebar_open;
      })
    },
    mounted() {
        this.loadUserNotifications();
    },
    props: {},
    data() {
        return {
            sidebar_open: false,
            notifications: [],
            loading: true,
        };
    },
    methods: {
        loadUserNotifications(notification = null) {
            axios.post('/notification/loadUserNotifications')
                .then((response) => {
                    this.notifications = response.data;
                    this.loading = false;

                    if(notification !== null) {
                      window.location.href = notification.action_button_url;
                    }
                });
        },
        goToActionUrl(notification) {
            axios.post('/notification/markAsRead', {
                notification_ids: [notification.id],
            }).then(() => {
                this.loadUserNotifications(notification);
              gtag('event', 'notification_sidebar_interaction', {
                'event_category': 'engagement',
                'event_label': 'Notification action clicked',
                'value': 'Notification action clicked',
              });
            });
        },
        markAsRead(notification) {
            axios.post('/notification/markAsRead', {
                notification_ids: [notification.id],
            }).then(() => {
                this.loadUserNotifications();
                gtag('event', 'notification_sidebar_interaction', {
                  'event_category': 'engagement',
                  'event_label': 'Notification marked as read',
                  'value': 'Notification marked as read',
                });
            });
        },
        markAllAsRead() {
            axios.post('/notification/markAsRead', {
                notification_ids: this.notifications.map(notification => notification.id),
            }).then(() => {
                this.loadUserNotifications();
              gtag('event', 'notification_sidebar_interaction', {
                'event_category': 'engagement',
                'event_label': 'All notifications marked as read',
                'value': 'All notifications marked as read',
              });
            });
        },
    },
    watch: {
        sidebar_open() {
          if(this.sidebar_open) {
              document.getElementById('body').classList.add('notification-sidebar-open');
              gtag('event', 'notification_sidebar_interaction', {
                'event_category': 'engagement',
                'event_label': 'Notification sidebar opened',
                'value': 'Notification sidebar opened',
              });
          }  else {
              document.getElementById('body').classList.remove('notification-sidebar-open');
            gtag('event', 'notification_sidebar_interaction', {
              'event_category': 'engagement',
              'event_label': 'Notification sidebar closed',
              'value': 'Notification sidebar closed',
            });
          }
        },
    },
};
</script>
